import useProcesoMatricula from "../../hooks/useProcesoMatricula";

const ModalHorarioError = () => {
  let { errorCursoServices } = useProcesoMatricula();

  return (
    <div
      className="modal fade"
      id="errorCurso"
      tabIndex={-1}
      data-bs-backdrop="static"
      aria-labelledby="exampleModalLabelerror"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-bottom-0 pb-0">
            <h5 className="modal-title" id="exampleModalLabelerror" />
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body pb-0 pt-0">
            {errorCursoServices?.includes("|") ? (
              <div className="text-center">
                <div>


                  <div className="d-none d-md-block d-lg-block icon-pendiente warning  animate__animated animate__wobble animate-warning ">
                    <span className="body animate__animated animate__wobble animate-warning" />
                    <span className="dot " />
                  </div>
                </div>
                <h5 className="text-uppercase">
                  {errorCursoServices?.split("|")[0]}
                </h5>

                <div className="mt-2 px-4">
                  <ul className="ps-4 pe-4 text-justify m-0" style={{ listStyle: "none", textAlign: "left" }}>
                    {(errorCursoServices?.split("|").slice(1) || [])
                      .map((msg, i) => msg.trim())
                      .filter(Boolean)
                      .map((msg, i) => (
                        <li key={i} className="d-flex gap-1 mb-1 align-items-start justify-content-start">
                          <i className="pi pi-times-circle flex-shrink-0" style={{ marginTop: 2, color: "#B01333" }} />
                          <span>{msg}</span>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            ) : (
              <div className="text-center">
                <div>
                  <div
                    className="swal2-icon swal2-error swal2-animate-error-icon"
                    style={{ display: "flex" }}
                  >
                    <span className="swal2-x-mark">
                      <span className="swal2-x-mark-line-left" />
                      <span className="swal2-x-mark-line-right" />
                    </span>
                  </div>
                </div>
                <h5 className="text-uppercase">
                  Ocurrió un inconveniente inesperado
                </h5>
                <p>{errorCursoServices && errorCursoServices}.</p>
              </div>
            )}
          </div>


          {errorCursoServices?.split("|")[1] ? (
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Continuar
              </button>
            </div>
          ) : (
            <div className="modal-footer"></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalHorarioError;
